// @flow
import { toastError } from 'bench-internal-theme';
import { Mutation, Query } from '@apollo/client/react/components';
import React, { Component } from 'react';

import type { PersonSearchResult } from './types';
import { GET_ASSIGNED_PERSONS, REPLACE_PRINCIPAL_PERSON, SEARCH_EXTERNAL_USERS } from './queries';
import SearchAndAssignPerson from './SearchAndAssignPerson';

const getPersonsFromQueryData = (data: any): Array<PersonSearchResult> =>
  (data && data.persons && data.persons.data) || [];

type SearchAndAssignPrimaryContactContainerProps = {
  clientId: string,
  onClientUpdate?: () => any,
};

type SearchAndAssignPrimaryContactContainerState = {
  searchString: string,
  selectedPerson: any,
};

class SearchAndAssignPrimaryContactContainer extends Component<
  SearchAndAssignPrimaryContactContainerProps,
  SearchAndAssignPrimaryContactContainerState,
> {
  static defaultProps = {
    onClientUpdate: undefined,
  };

  constructor() {
    super();
    this.state = {
      searchString: '',
      selectedPerson: null,
    };
  }

  handleSelectedPersonChanged = (selectedPerson: PersonSearchResult) => {
    this.setState({ selectedPerson });
  };

  handleSearchStringChanged = (searchString: string) => {
    this.setState({ searchString });
  };

  replacePrincipalPersonOnClient = (replacePrincipalPerson: Object => any) => {
    const { clientId } = this.props;
    const { selectedPerson } = this.state;
    if (!selectedPerson) {
      return;
    }
    replacePrincipalPerson({
      variables: {
        clientId,
        personId: selectedPerson.id,
      },
    });
  };

  handlePersonAttached = () => {
    const { onClientUpdate } = this.props;
    if (typeof onClientUpdate === 'function') {
      onClientUpdate();
    }
    this.setState({ selectedPerson: null });
  };

  handleAttachPersonError = () =>
    toastError(
      'Unable to assign user',
      'An error occurred when trying to attach the user. It might work if you give it another try.',
    );

  render() {
    const { clientId } = this.props;
    const { searchString, selectedPerson } = this.state;
    const shouldSearch = !!searchString && searchString.length >= 3;

    return (
      <Mutation
        mutation={REPLACE_PRINCIPAL_PERSON}
        onCompleted={this.handlePersonAttached}
        onError={this.handleAttachPersonError}
        refetchQueries={[{ query: GET_ASSIGNED_PERSONS, variables: { clientId } }]}
      >
        {replacePrincipalPerson => (
          <Query
            query={SEARCH_EXTERNAL_USERS}
            skip={!shouldSearch}
            variables={{ search: searchString }}
          >
            {({ data, loading }) => (
              <SearchAndAssignPerson
                attachSelectedPersonToClient={() =>
                  this.replacePrincipalPersonOnClient(replacePrincipalPerson)
                }
                searchString={searchString}
                isLoading={loading && shouldSearch}
                onSearchStringChanged={this.handleSearchStringChanged}
                onSelectedPersonChanged={this.handleSelectedPersonChanged}
                persons={getPersonsFromQueryData(data)}
                selectedPerson={selectedPerson}
                submitLabel="Replace Primary Contact"
              />
            )}
          </Query>
        )}
      </Mutation>
    );
  }
}

export default SearchAndAssignPrimaryContactContainer;
